import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, LogService } from '@ridango/core';
import { HelperService } from '../../../../services/helper.service';
import Env from '@ridango/core/env';
import { FeatureFlagService } from '@ridango/feature-flags';
import { MatDialog } from '@angular/material/dialog';
import {
    ApplicationFacade,
    CustomerAccountsFacade,
    CustomerFacade,
    DeviceNotificationService
} from '@ridango/components';
import { NewMobileMenuAbstractComponent } from '../new-mobile-menus-abstract.component';
import { MessagesService } from '../../../../../services/messages.service';
import { AnalyticsService } from '@ridango/core/lib/services/analytics.service';
import { take, takeUntil } from 'rxjs/operators';
import { Actions } from '@ngrx/effects';
import { PermissionsFacade } from '@ridango/components/lib/permissions';

@Component({
    selector: 'gl-mobile-menu-vl',
    templateUrl: './mobile-menu-vl.component.html',
    styleUrls: ['./mobile-menu-vl.component.scss']
})
export class MobileMenuVlComponent extends NewMobileMenuAbstractComponent implements OnInit {
    public termsSectionLinks = [
        {
            title: 'MENU_USER_TERM',
            link: 'MAIN_MENU_TERMS_OF_USE_LINK',
            srcIcon: 'file-solid.svg'
        },
        {
            title: 'MENU_TRAVEL_CONDITIONS',
            link: 'MAIN_MENU_TERMS_OF_TRAVEL_LINK',
            srcIcon: 'file-solid.svg'
        },
        {
            title: 'MENU_HANDLING_PERSONAL_DATA',
            link: 'MAIN_MENU_HANDLING_PERSONAL_DATA_LINK',
            srcIcon: 'file-shield-solid.svg'
        },
        {
            title: 'MENU_TERMS_PURCHASE',
            link: 'MAIN_MENU_TERMS_OF_PURCHASE_LINK',
            srcIcon: 'file-solid.svg'
        }
    ];
    public paymentsTicketsSection = [
        {
            title: 'MAIN_MENU_LOSE_WARRANTY',
            link: 'https://vl.se/biljetter/villkor-och-ersattning/',
            srcIcon: 'file-solid.svg'
        },
        {
            title: 'MAIN_MENU_DELAY_COMPENSATION',
            link: 'https://vl.se/biljetter/villkor-och-ersattning/forseningsersattning/',
            srcIcon: 'delay-refund.svg'
        }
    ];

    constructor(
        protected ls: LogService,
        public ridangoAuth: AuthService,
        public helperService: HelperService,
        public translate: TranslateService,
        @Inject('ENV') public env: Env,
        protected featureFlags: FeatureFlagService,
        protected dialog: MatDialog,
        protected applicationFacade: ApplicationFacade,
        protected customerFacade: CustomerFacade,
        public permissionsFacade: PermissionsFacade,
        public actions$: Actions,
        public analyticsService: AnalyticsService,
        public messagesService: MessagesService,
        private deviceNotificationService: DeviceNotificationService,
        customerAccountsFacade: CustomerAccountsFacade
    ) {
        super(
            ls,
            ridangoAuth,
            helperService,
            translate,
            env,
            dialog,
            applicationFacade,
            customerFacade,
            permissionsFacade,
            actions$,
            messagesService,
            analyticsService,
            customerAccountsFacade
        );
    }

    ngOnInit() {
        super.ngOnInit();
        this.receivedMessagesCount$.pipe(take(1), takeUntil(this.componentDestroyed$)).subscribe(({ unread }) => {
            this.deviceNotificationService.setBadgeCount(unread);
        });
    }
}
